import { type Perfume, ComponentCategory } from "@/models";
import {
  Timestamp,
  type FirestoreDataConverter,
  type QueryDocumentSnapshot,
} from "firebase/firestore";
import { perfumeFromDb, type PerfumeDb } from "./PerfumeDbModel";

export * from "./PerfumeDbModel";

export type KeyOfT<T extends object> = Extract<keyof T, string>;

export function keyOf<T extends object>(field: KeyOfT<T>): KeyOfT<T> {
  return field;
}

export const PerfumeConverter: FirestoreDataConverter<Perfume, PerfumeDb> = {
  toFirestore: (perfume: Perfume): PerfumeDb => {
    return {
      formulaNumber: perfume.formulaNumber ?? "",
      created: Timestamp.fromDate(perfume.created),
      name: perfume.name,
      email: perfume.email,
      title: perfume.title,
      username: perfume.username,
      userLastName: perfume.userLastName,
      workshopLocationId: perfume.workshopLocation?.workshopLocationId ?? "",
      components: perfume.components.map((component) => {
        return {
          name: component.name,
          volume: component.volume,
          category: ComponentCategory[component.category],
          numeroDeLot: component.numeroDeLot,
          ...(component.suggested ? { suggested: true } : {}),
        };
      }),
      comment: perfume.comment,
      lockedAt: perfume.lockedAt ? Timestamp.fromDate(perfume.lockedAt) : null,
    };
  },
  fromFirestore: function (snapshot: QueryDocumentSnapshot<PerfumeDb>): Perfume {
    return perfumeFromDb(snapshot.id, snapshot.data());
  },
};
